<template>
  <button
      :title="translationActive ? 'View original': 'Translate to English using AI'"
      :class="['translation-button-container', !translationInProgress ? 'translation-button-container-show-background' : '']"
      @click.prevent="requestTranslation"
  >
    <LoadingSpinnerIcon v-if="translationInProgress"/>
  </button>
</template>
<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import LoadingSpinnerIcon from "./LoadingSpinnerIcon.vue";

export default {
  name: 'TranslateButton',
  components: {LoadingSpinnerIcon},
  props: {
    docId: {
      type: String,
      required: true,
    },
    translationActive: {
      type: Boolean,
      default: false
    },
    haveTranslations: {
      type: Boolean,
      default: false
    },
  },
  emits: ['translationFinished', 'translationRequested', 'translationFailed'],
  data() {
    return {
      translationInProgress: false,
    }
  },
  methods: {
    requestTranslation() {
      if (this.haveTranslations) {
        // we've already translated so no need to fetch anything.
        this.$emit('translationRequested')
        this.$nextTick(() => {
          this.$emit('translationFinished', null)
        })
        return
      }
      this.translationInProgress = true
      this.$emit('translationRequested')

      this.fetchTranslation()
          .then(response => {
            this.translationInProgress = false
            this.$emit('translationFinished', response.data)
          })
          .catch(error => {
            this.$emit('translationFinished', null)
            this.$emit('translationFailed', error)
            this.translationInProgress = false
          })
    },

    fetchTranslation() {
      const csrftoken = Cookies.get('csrftoken')
      const form = new FormData()
      form.append('doc_id', this.docId)
      return axios.post(
          `/en/message-search/get_translation/`,
          form,
          {'headers': {
              'X-CSRFToken': csrftoken,
            }}
      )
    }
  }
}

</script>
<style>
.translation-button-container {
  height: 24px;
  width: 24px;
  vertical-align: middle;
}

.translation-button-container-show-background {
  background:
      url('/images/icons/icon-translate.svg')
      no-repeat
      center center;
}
</style>